import '../css/fullscreen.scss';
import markup from './markup';
import Root from './containers/Root';
import screens from './screens';
import checkMobileAndTablet from './utils/checkMobileAndTablet';
import checkScreenResolution from './utils/checkScreenResolution';
import showBackStub from './utils/showBackStub';
import createElement from './utils/createElement';

markup();

window.__backStubMobile__ = <div class="back-stub-mobile">
    <div class="back-stub-mobile_img"/>
    <div class="back-stub-mobile_title">Упс! Эту страницу можно посмотреть <br/> только с компьютера</div>
</div>;
window.__backStubResolution__ = <div class="back-stub-resolution">
    <div class="back-stub-resolution_img"/>
    <div class="back-stub-resolution_title">Разверните окно браузера <br/> для полноты ощущений</div>
</div>;

document.getElementsByTagName('body')[0].appendChild(window.__backStubMobile__);
document.getElementsByTagName('body')[0].appendChild(window.__backStubResolution__);

if (checkMobileAndTablet()){
    showBackStub('mobile');
} else {
    window.addEventListener('resize', checkScreenResolution, true);
    checkScreenResolution();
    const root = new Root(screens);
    root.render('root');
}






// WEBPACK FOOTER //
// ./src/js/index.js